import {
  AUTH_SUCCESS,
  SESSION_TIMEOUT_MODAL,
  UPDATE_TIMEOUT,
  SAVE_DOCUSIGN_INFO,
} from '../types/auth'
import { SAVE_UPDATED_SHOP, SAVE_FLAG_NAL_TAXES_ONLY } from '../types/shop'
import { saveSession, getSession, saveDocuSign } from '../utils/api'

const session = getSession()

const initState = {
  session,
  showSessionTimeoutModal: false,
  timerId: null,
  flagisNalTaxesOnly: false,
}

export default (state = initState, action) => {
  switch (action.type) {
    case AUTH_SUCCESS:
      saveSession(action.payload.session)
      return { ...state, session: action.payload.session }
    case UPDATE_TIMEOUT:
      return { ...state, timerId: null }
    case SAVE_UPDATED_SHOP:
      saveSession(action.payload.session)
      return {
        ...state,
        session: { ...state.session, ...action.payload.session, assignedShop: action.payload.shop },
      }
    case SESSION_TIMEOUT_MODAL:
      return { ...state, showSessionTimeoutModal: action.payload }
    case SAVE_DOCUSIGN_INFO:
      saveDocuSign(action.payload)
      return { ...state, docuSign: action.payload }
    case SAVE_FLAG_NAL_TAXES_ONLY:
      return { ...state, flagisNalTaxesOnly: action.payload.flagisNalTaxesOnly }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js